/**
 * @fileoverview Custom OpenLayers control for resetting the map view.
 * @module map/ResetViewControl
 */

/**
 * Custom OpenLayers control that provides a button to reset the map view to initial bounds.
 * Displays a reset icon that triggers the onReset callback when clicked.
 * @class
 * @extends ol.control.Control
 */
export class ResetViewControl extends ol.control.Control {
    /**
     * Creates a new ResetViewControl instance.
     * @param {Object} [options={}] - Control options
     * @param {Function} [options.onReset] - Callback invoked when reset button is clicked
     * @param {HTMLElement} [options.target] - Target element to render the control into
     */
    constructor(options = {}) {
        const button = document.createElement('button');
        button.innerHTML = '<i class="bi bi-arrow-counterclockwise"></i>';
        button.className = 'ol-reset-view-button';
        button.title = 'Reset map view';

        const element = document.createElement('div');
        element.className = 'ol-reset-view ol-unselectable ol-control';
        element.appendChild(button);

        super({
            element: element,
            target: options.target
        });

        this.onReset = options.onReset || (() => {});

        // Handle button click
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onReset();
        });
    }
}
